export default "__VITE_ASSET__02126ba5__"